'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Component2 = require('../../Component');

var _Component3 = _interopRequireDefault(_Component2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _documentOffset = require('document-offset');

var _documentOffset2 = _interopRequireDefault(_documentOffset);

var _main = require('../templates/main');

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _stringifyDefault = function _stringifyDefault(value) {
    if (value && typeof value.toString === 'function') {
        return value.toString('dd.mm.yyyy');
    } else {
        return value;
    }
};

var Main = function (_Component) {
    _inherits(Main, _Component);

    function Main() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Main);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Main.__proto__ || Object.getPrototypeOf(Main)).call.apply(_ref, [this].concat(args))), _this), _this.template = _main2.default, _this.state = {
            active: false,
            hover: false
        }, _this._handleFocus = function (event) {
            _this.setState({ active: true }).then(function () {
                if (typeof _this.props.onFocus === 'function') {
                    _this.props.onFocus(event);
                }
            });
        }, _this._handleBodyClick = function () {
            var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (_this.state.active && !_this.root.contains(event.target)) {
                _this.setState({ active: false });
            }

            return _this;
        }, _this._handleSubmit = function (value) {
            _this.input.value = value;

            return _this.setState({ active: false });
        }, _this._handleCancel = function () {
            return _this.setState({ active: false });
        }, _this._handleCalendarClick = function () {
            _this.input && _this.input.focus();
        }, _this._handleHover = function () {
            return _this.setState({ hover: true });
        }, _this._handleRootBlur = function () {
            return _this.setState({ hover: false });
        }, _this._rootRef = function (el) {
            _this.root = el;
        }, _this._inputRef = function (el) {
            if (typeof _this.props.elementRef === 'function') {
                _this.props.elementRef(el);
            }

            _this.input = el;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Main, [{
        key: '_getPosition',
        value: function _getPosition() {
            var docH = window.document.documentElement.offsetHeight,
                docW = window.document.documentElement.offsetWidth,
                offset = (0, _documentOffset2.default)(this.root),
                position = {};

            // positioning
            // DP height + input height + 18
            if (docH - offset.top - (377 + this.root.offsetHeight + 18) <= 0) {
                position.bottom = 'calc(100% + 2px)';
                position.top = 'auto';
                position.transformOrigin = 'bottom';
            } else {
                position.top = 'calc(100% + 2px)';
                position.bottom = 'auto';
                position.transformOrigin = 'top';
            }

            // DP width + 18
            if (docW - offset.left - 290 <= 0) {
                position.left = 'auto';
                position.right = 0;
            }

            return position;
        }
    }, {
        key: 'computeStyleHash',
        value: function computeStyleHash() {
            return String(this.state.hover) + String(this.props.disabled);
        }
    }]);

    return Main;
}(_Component3.default);

Main.propTypes = {
    minYear: _propTypes2.default.number,
    maxYear: _propTypes2.default.number,
    minMonth: _propTypes2.default.number,
    maxMonth: _propTypes2.default.number,
    yearChange: _propTypes2.default.bool,
    allowedWeekDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.bool, _propTypes2.default.array]),
    deniedDates: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.bool, _propTypes2.default.array]),
    allowedDates: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.bool, _propTypes2.default.array]),
    firstDay: _propTypes2.default.number,
    isPeriod: _propTypes2.default.bool,
    onSubmit: _propTypes2.default.func,
    onCancel: _propTypes2.default.func,
    elementRef: _propTypes2.default.func,
    onFocus: _propTypes2.default.func,
    theme: _propTypes2.default.object,
    stringify: _propTypes2.default.func,
    disabled: _propTypes2.default.bool,
    className: _propTypes2.default.string
};
Main.defaultProps = {
    readOnly: true,
    stringify: _stringifyDefault
};
Main.displayName = 'DateInput';
exports.default = Main;